module.exports = __webpack_public_path__ + "static/media/aws-logo.2f52a08b.png";